export default {
  VISUAL_SEARCH: "/item/visual-search",
  PRODUCT: "/products",
  OUTFIT: "/styles/outfits/search",
  FAVORITE: "/favorites",
  FAVORITE_SEARCH: "/favorites/search",
  OUTFIT_FAVORITE: "/favorites/styles",
  OUTFIT_FAVORITE_SEARCH: "/favorites/styles/search",
  VISUAL_SEARCH_FEEDBACK: "/item/visual-search/feedback",
  VISUAL_SEARCH_EMPTY_RESULT: "/item/visual-search/empty-result",
  PRODUCT_SKUS: "/favorites",
  PRODUCT_SKUS_WITH_IMAGE: "/l2s-with-images"
};
